import { render, staticRenderFns } from "./SidebarAddEvent.vue?vue&type=template&id=02461d9e&"
import script from "./SidebarAddEvent.vue?vue&type=script&lang=js&"
export * from "./SidebarAddEvent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports